/**
 * Web-side mirror of the backend `FeatureGate` enum in
 * `api/src/clients/statsig.ts`. The web bundle cannot import from `api/`, so the
 * dev panel uses this copy to classify each gate's scope (frontend / backend /
 * both) and to list backend-only gates.
 *
 * Keep in sync with the backend enum. Drift only affects the dev panel's badges
 * and rows — never runtime behavior — and is guarded by
 * `scripts/featureGateParity.test.ts`, which fails if this list diverges from the
 * backend enum.
 */
export const BackendFeatureGate = {
  AIAssistantMCPTool: 'ai_assistant_mcp_tool',
  ApplicationAutoCheckRecap: 'application_auto_check_recap',
  ApprovalConditions: 'approval_conditions',
  CorrectionsReportCroppedCanvas: 'corrections_report_cropped_canvas',
  CustomTaskFieldColumns: 'custom_task_field_columns',
  FinixPaidByCapture: 'finix_paid_by_capture',
  CorrectionsReportImageCache: 'corrections_report_image_cache',
  EnableTaskReminderEmails: 'enable_task_reminder_emails',
  GISAutoFill: 'gis_autofill',
  GISPropertyColumns: 'gis_property_columns',
  ImportLicenseClaims: 'import_license_claims',
  InspectionCalendarExternalIntegration: 'inspection_calendar_external_integration',
  InternalStaffAI: 'internal_staff_ai',
  ManualPaidByCapture: 'manual_paid_by_capture',
  OpenSearchApplyPrismaFilters: 'open_search_apply_prisma_filters',
  OpenSearchCitizenRecordView: 'open_search_citizen_record_view',
  OpenSearchFilesInModuleView: 'open_search_files_in_module_view',
  OpenSearchRecordsForPublicInModuleView: 'open_search_records_for_public_in_module_view',
  OpenSearchInspectionAttemptCitizenView: 'open_search_inspection_attempt_citizen_view',
  OpenSearchInspectionAttemptStaffView: 'open_search_inspection_attempt_staff_view',
  OpenSearchSavedTableView: 'open_search_saved_table_view',
  OpenSearchUniversalSearchForEntities: 'open_search_universal_search_for_entities',
  OpenSearchUniversalSearchForRecords: 'open_search_universal_search_for_records',
  PaymentusPubSub: 'paymentus_pub_sub',
  RecordColumnsInTaskTables: 'record_columns_in_task_tables',
  SaveToOpenSearch: 'save_to_open_search',
  SearchOpenSearchRecords: 'search_open_search_records',
  SettlementTracking: 'settlement_tracking',
  RenewalsOverhaul: 'renewals_overhaul',
  WorkOrderReportingPreview: 'work_order_reporting',
} as const

export const BACKEND_GATE_VALUES = new Set<string>(Object.values(BackendFeatureGate))
